import axios from '../utils/request'

const GetOrderMainData = (OrderID) => {
  return axios.get('GetOrderMainData?OrderID=' + OrderID, {
  })
}

const GetOrderDetailData = (OrderID) => {
  return axios.get('GetOrderDetailData?OrderID=' + OrderID, {
  })
}

const ChangeVoucher = (url1, url2, Voucher, Voucher2, OrderID) => {
  return axios.get('ChangeVoucher?url1=' + url1 + '&url2=' + url2 + '&Payment_Voucher=' + Voucher + '&Payment_Voucher2=' + Voucher2 + '&OrderID=' + OrderID, {
  })
}

const OrderMainData = (loginInfo) => {
  return axios.post('GetOrderMainData', {
    ...loginInfo
  })
}

const ChangeOrderMainInfo = (loginInfo) => {
  return axios.post('ChangeOrderMainInfo', {
    ...loginInfo
  })
}

export {
  OrderMainData,
  GetOrderMainData,
  GetOrderDetailData,
  ChangeOrderMainInfo,
  ChangeVoucher
}
